const initialState = {
  user: {
    name: "TEST",
  },
  orderInfo: {},
  userData: {},
  sanctionData: {},
  primaryDetails: {},
  merchantDetails: {},
  basicProfilePayload: {},
  ingestionResponse: {},
  selectedSectionData: {},
  selectedSectionId: {},
  selectedClassData: [],
  customerCred: {},
  homeUrl: "",
  parentDetails: {},
  ssoCusDetails: {
    customerRefNum: "28411819ckbsnt",
    customerId: 1509535893,
    mobileNumber: "9008204893",
    Authorization: "CsgE44FnzcnUJ5CtdoSdc346YvV3UR2x51P2a/O0PBk=",
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "SET_STATE":
      return {
        ...state,
        userInfo: action.data ? true : false,
        userDetails: action.data,
      };
    case "REJ_STATE":
      return {
        ...state,
        userInfo: false,
        userDetails: {},
      };
    case "SAVE_ORDER":
      return {
        ...state,
        orderInfo: action.data,
      };
    case "USER_INFO":
      return {
        ...state,
        userData: action.data,
      };
    case "SANCTION_INFO":
      return {
        ...state,
        sanctionData: action.data,
      };
    case "SAVE_PRIMARY_DETAILS":
      console.log("SAVE_PRIMARY_DETAILS", action.data);
      return {
        ...state,
        primaryDetails: action.data,
      };
    case "SAVE_MERCHANT_DETAILS":
      return {
        ...state,
        merchantDetails: action.data,
      };
    case "SAVE_BASIC_PROFILE_PAYLOAD":
      return {
        ...state,
        basicProfilePayload: action.payload,
      };
    case "SAVE_QEC_INGESTION_RESPONSE":
      return {
        ...state,
        ingestionResponse: action.payload,
      };
    case "SAVE_SELECTED_CLASS_DATA":
      return {
        ...state,
        selectedClassData: action.payload,
      };
    case "SAVE_SELECTED_SECTION_DATA":
      return {
        ...state,
        selectedSectionData: action.payload,
      };
    case "SAVE_SELECTED_SECTION_ID":
      return {
        ...state,
        selectedSectionId: action.payload,
      };
    case "SAVE_CUSTOMER_CRED":
      return {
        ...state,
        customerCred: action.payload,
      };
    case "SAVE_HOME_URL":
      return {
        ...state,
        homeUrl: action.payload,
      };
    case "SAVE_PARENT_DETAILS_PAYLOAD":
      return {
        ...state,
        parentDetails: action.payload,
      };
    case "SAVE_SSO_CUST_DETAILS":
      return {
        ...state,
        ssoCusDetails: action.payload,
      };
    case "CLEARSTATE":
      return {
        ...initialState,
      };

    default:
      return state;
  }
};
